import state from './noticeState';
import mutations from './noticeMutations';
import getters from './noticeGetters';
import actions from './noticeActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
